<template>
  <div>
    <b-modal
      size="md"
      hide-header-close
      no-close-on-backdrop
      hide-footer
      :id="`delete-document-${data.id}`"
      title="EXCLUIR TIPO DE DOCUMENTO"
    >
      <div class="row">
        <ReleasesDelete
          type="finance_configuration_document_types"
          :id="data.id"
          @total="handleVerifyReleasesToDelete"
        />
        <div class="col-md-12" v-if="totalReleases > 0">
          Há {{ totalReleases }} lançamento(s) cadastrado(s) neste tipo de
          documento. O que deseja fazer?
        </div>
        <div class="col-md-12" v-if="totalReleases > 0">
          <div class="form-check">
            <input
              v-model="type_delete"
              class="form-check-input"
              type="radio"
              name="typeDelete"
              id="type_only_delete"
              value="type_only_delete"
            />
            <label class="form-check-label" for="type_only_delete"
              >Deixar todos os lançamentos sem tipo de documento</label
            >
          </div>
          <div class="form-check">
            <input
              v-model="type_delete"
              class="form-check-input"
              type="radio"
              name="typeDelete"
              id="type_delete_transfer"
              value="type_delete_transfer"
            />
            <label class="form-check-label" for="type_delete_transfer"
              >Transferir lançamentos para outra tipo de documento</label
            >
          </div>
        </div>
        <div
          class="col-md-12"
          v-if="totalReleases > 0 && type_delete == 'type_delete_transfer'"
        >
          <select v-model="transfer_id" class="form-control">
            <option :value="null">SELECIONE...</option>
            <option
              v-for="(item, key) in finance_configuration_document_types"
              :value="item.id"
              :key="key"
              v-show="item.id != data.id"
            >
              {{ item.description }}
            </option>
          </select>
        </div>
        <div class="col-md-12 pt-0 pb-0">
          <ErrorsMessages :errors="errorsDelete" />
        </div>
        <div class="col-md-6">
          <v-btn
            @click="$bvModal.hide(`delete-document-${data.id}`)"
            class="btn-cancel"
          >
            <i class="fas fa-times mr-2 text-twenty"></i>
            CANCELAR
          </v-btn>
        </div>
        <div class="col-md-6 text-right">
          <v-btn :disabled="loading" @click="handleDelete" class="btn-delete">
            <i class="fas fa-check mr-2 text-twenty"></i>
            {{ loading ? "CARREGANDO" : "EXCLUIR" }}
          </v-btn>
        </div>
      </div>
    </b-modal>
    <div class="row">
      <div class="col-md-12">
        <label>Descrição</label>
        <input type="text" class="form-control" v-model="description" />
      </div>
      <div class="col-md-12">
        <label>Status</label>
        <select v-model="status" class="form-control">
          <option value="1">ATIVO</option>
          <option value="0">INATIVO</option>
        </select>
        <small
          >Apenas tipos de documento ativos poderão ser utilizadas nos
          lançamentos!</small
        >
      </div>
      <div class="col-md-12 pt-0 pb-0"><ErrorsMessages :errors="errors" /></div>
      <div class="col-md-12 text-right">
        <v-btn
          v-if="permission('remove', 'financial_document_types')"
          class="btn-delete mr-1"
          @click="deleteDocuments"
        >
          <i class="fas fa-trash mr-2"></i>
          EXCLUIR</v-btn
        >
        <v-btn :disabled="loading" @click="update" class="btn-save">
          <i class="fas fa-check mr-2 text-twenty"></i>
          {{ loading ? "CARREGANDO" : "SALVAR" }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages";

import ReleasesDelete from "../Delete/releases.vue";

import api from "../../../../services/api";

import toast from "../../../../lib/ToastNotification";

import permission from "../../../../lib/permission";

export default {
  name: "Edit",

  components: {
    ErrorsMessages,
    ReleasesDelete,
  },

  props: {
    data: Object,
  },

  data() {
    return {
      totalReleases: 0,
      type_delete: null,
      finance_configuration_document_types: [],
      transfer_id: null,
      description: "",
      status: "",
      loading: false,
      errors: [],
      errorsDelete: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    permission,

    retrieve() {
      let { data } = this;

      this.description = data.description;
      this.status = data.status;
      this.financeConfigurationDocumentTypes();
    },

    async financeConfigurationDocumentTypes() {
      try {
        const response = await api.get(
          "/rest-home/financial/configuration/document-types-actives"
        );

        const { data } = response.data;

        this.finance_configuration_document_types = data;
      } catch (error) {
        console.log(error);
      }
    },

    deleteDocuments() {
      this.$bvModal.show(`delete-document-${this.data.id}`);
    },

    async handleDelete() {
      try {
        let {
          data: { id },
          transfer_id,
          type_delete,
        } = this;

        let data = { id, transfer_id, type_delete };

        const response = await api.delete(
          "/rest-home/financial/configuration/document-types",
          {
            data,
          }
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");

          this.$bvModal.hide(`edit-${this.data.id}`);

          this.$emit("success");
          this.errorsDelete = [];
        } else {
          this.errorsDelete = errors;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async update() {
      try {
        this.loading = true;

        const { data, description, status } = this;

        let params = {
          id: data.id,
          description,
          status,
        };

        const response = await api.put(
          "/rest-home/financial/configuration/document-types",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");

          this.$bvModal.hide(`edit-${this.data.id}`);

          this.$emit("success");
          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    handleVerifyReleasesToDelete(total) {
      this.totalReleases = total;

      if (total == 0) {
        this.type_delete = "type_only_delete";
      } else {
        this.type_delete = null;
      }
    },
  },
};
</script>
